(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('Notifier', NotifierFactoryFunc);

    function NotifierFactoryFunc() {
        var message= '';
        var type = 'success';
        var loading = false;
        var notification = false;
        return {
            message: function () { return message; },
            type: function () { return type; },

            setMessage: function(msg) {message = msg;},
            setType: function(t) {type = t;},
            show: function(t,m){
                this.setMessage(m);
                this.setType(t);
                this.toggleNotification();
            },

            notificationChanged: function() {return notification; },
            toggleNotification: function() { notification = new Date().getTime();},

            setLoading: function(l) { loading = l; },
            getLoading: function() { return loading; }
        };
    }
})();